const setupCategoryRail = () => {
  const categoryRail = document.querySelector('[data-rail="categories"]');
  if (!categoryRail || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  let categoryRailPaused = false;

  const advanceCategoryRail = () => {
    if (categoryRailPaused) return;

    const firstCard = categoryRail.querySelector('.cs-category');
    const cardWidth = firstCard ? firstCard.getBoundingClientRect().width : 212;
    const gap = Number.parseFloat(getComputedStyle(categoryRail).gap) || 0;
    const step = cardWidth + gap;
    const end = categoryRail.scrollWidth - categoryRail.clientWidth;

    if (categoryRail.scrollLeft >= end - step / 2) {
      categoryRail.scrollTo({ left: 0, behavior: 'smooth' });
      return;
    }

    categoryRail.scrollBy({ left: step, behavior: 'smooth' });
  };

  window.setInterval(advanceCategoryRail, 2000);
  categoryRail.addEventListener('mouseenter', () => { categoryRailPaused = true; });
  categoryRail.addEventListener('mouseleave', () => { categoryRailPaused = false; });
  categoryRail.addEventListener('focusin', () => { categoryRailPaused = true; });
  categoryRail.addEventListener('focusout', () => { categoryRailPaused = false; });
};

const setupBestSellerRail = () => {
  const bestSellerRail = document.querySelector('[data-rail="best-sellers"]');
  if (
    !bestSellerRail ||
    bestSellerRail.dataset.autoplayReady === 'true' ||
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) return;

  bestSellerRail.dataset.autoplayReady = 'true';
  bestSellerRail.style.scrollSnapType = 'x mandatory';
  bestSellerRail.querySelectorAll('.cs-product-card').forEach((card) => {
    card.style.scrollSnapAlign = 'start';
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    setupCategoryRail();
    setupBestSellerRail();
  }, { once: true });
} else {
  setupCategoryRail();
  setupBestSellerRail();
}

document.addEventListener('shopify:section:load', setupBestSellerRail);
window.setTimeout(setupBestSellerRail, 1000);
